module.exports = __webpack_public_path__ + "img/history_btn.a3c8ad09.png";